export default [
    {
        header: true,
        title: ''
    },
    {
        title: 'ホーム',
        icon: 'home',
        href: '/company/dashboard',
    },
    {
        title: '支払い',
        icon: 'yen-sign',
        href: '/company/payment',
    },
    {
        title: '各種設定',
        icon: 'cog',
        href: '/company/setting',
    },
]
